/**
 * 智慧櫃合約狀態 Enum
 * @enum {number}
 */
export const LockerContractStatus = Object.freeze({
  Active: 1, // 使用中
  Expired: 2, // 已到期
  Expiring: 3 // 即將到期（30 天內，且無續約）
})
